import { IconClipboardList } from '@tabler/icons-react';

const units = {
    id: 'units',
    title: 'UNITS',
    icon: IconClipboardList,
    type: 'group',
    breadcrumbs: false,
    url: '/units',
    tags: [
        'unit',
        'units',
        'training unit',
        'course unit',
        'learning unit',
        'competency unit',
        'competency',
        'module',
        'module unit',
        'subject',
        'topic',
        'unit details',
        'unit information',
        'unit overview',
        'unit descriptor',
        'unit code',
        'unit title'
    ]
};

export default units;
